// extracted by mini-css-extract-plugin
export default {"timeline":"styles_timeline__+DgB5"};